export default {
  mSetLoaded(state, status) {
    state.loaded = status;
  },
  mSetLoading(state, status) {
    state.loading = status;
  },
  mOpenDetailDialog(state, detail) {
    state.detailDialog = true;
    state.detail = detail;
  },
  mCloseDetailDialog(state) {
    state.detailDialog = false;
    
  },
  mSetMappedLocations(state) {
    try {
      const list = state.locations.filter((data) => data.latitude && data.longitude);
      const options = { fillColor: 'red', fillOpacity: 0.5 };
      const wellOptions = { fillColor: 'blue', fillOpacity: 0.5 };
      const markers = list.map((item) => {
        item.type = item.type.trim()
        let productionPercent = item.production_percent ? parseFloat(item.production_percent) : 1;
        if(productionPercent < 10) {
          productionPercent = 15;
        }
        if(item.type == 'well') {
          productionPercent = 10;
        }
        const description = item.description ? item.description : '';
        const result = {
          id: item.code,
          type: item.type,
          name: item.location,
          productionPercent,
          description,
          radius: (productionPercent * 1000),
          options: item.type == 'well' ? wellOptions : options,
          position: {
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
          },
        };
        return { ...item, ...result };
      });
      state.mappedLocations = [...markers];
    } catch (error) {
      // error
    }
  },
  mSetZoomLevel(state, zoomLevel) {
    state.zoomLevel = zoomLevel;
    state.locationType = zoomLevel >= 8 ? 'well' : 'state';
  },
  mSetRadiusMarkers(state) {
    const locationType = state.locationType;
    if(state.lastLocationType == locationType && state.radiusMarkers.length) {
      return true;
    }
    let markers = state.mappedLocations.filter((item) => item.type === locationType);
    state.radiusMarkers = [...markers];
    state.lastLocationType = locationType;
  },
};
